import { DocumentSmartTextType } from "./types";

const DECIMAL_PLACES = 2;

/**
 * Pads a Number-type document smart text value to 2 decimal places when
 * `requireDecimals` is true. Mirrors `formatDocumentDateValue`'s shape — applied
 * at display time so the stored value stays the user's raw input.
 *
 * Returns the raw value unchanged when:
 *   - the value is empty / not a string,
 *   - the type isn't `number`,
 *   - `requireDecimals` is falsy,
 *   - the value doesn't parse to a finite number (defensive fallback so the
 *     textbox never renders `NaN`).
 */
export const formatDocumentNumberValue = (
  rawValue: string | null | undefined,
  type: DocumentSmartTextType,
  requireDecimals: boolean | undefined
): string => {
  if (!rawValue) return rawValue ?? "";
  if (type !== "number") return rawValue;
  if (!requireDecimals) return rawValue;
  const parsed = Number(rawValue);
  if (!Number.isFinite(parsed)) return rawValue;
  return parsed.toFixed(DECIMAL_PLACES);
};
